export default __webpack_public_path__ + "static/media/nazario.db210e58.png";